import QrCodeLink from "./cdtuQrCodeLink.vue";
export default {
  name: 'meetUpLogin',
  components: {
    'qrCode-link': QrCodeLink
  },
  methods: {
    //成都工业icon
    initHeuIcon() {
      document.title = 'CDTU数字化教育教学平台';
      let link = document.createElement('link');
      link.setAttribute('rel', 'shortcut icon');
      link.setAttribute('href', 'https://file.zhihuishu.com/zhs/b2cm/base1/202304/32387c8d69a94c769364d9d8efb5a12f.ico');
      let head = document.querySelectorAll('head');
      head[0].appendChild(link);
    }

  },

  mounted() {
    this.initHeuIcon();
  }

};